import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import { default as Header } from "../../Components/Header2/Header2";
import { default as Footer } from "../../Components/Footer/FooterSmall";

import useAPI from "../../Hooks/useAPI";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { forgotPassword } = useAPI();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      await forgotPassword(email);
      setSuccess(
        "If an account exists with this email, you will receive password reset instructions."
      );
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    }
  };

  return (
    <>
      <Header />
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <div className="forgot-password-header">
            <h2 className="forgot-password-title">Reset Your Password</h2>
            <p className="forgot-password-subtitle">
              Enter your email address and we'll send you instructions to reset
              your password.
            </p>
          </div>

          {error && <div className="error-message">{error}</div>}

          {success && <div className="success-message">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                required
              />
            </div>

            <button type="submit" className="forgot-password-submit-button">
              Send Reset Instructions
            </button>
          </form>

          <div className="mt-4 text-center">
            <button
              onClick={() => navigate("/user-login")}
              className="back-button"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
